import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Checkbox,
  Collapse,
  TextField,
  Typography,
} from '@material-ui/core';
import { loadTexts } from '../../../../config/texts';

import Section from '../Section';

import { updateOrganizationCancelation } from '../../actions';
import { fetchUser } from '../../../auth/actions';
const TEXT_KEY = "organization";

const styles = theme => ({
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  textFieldContainer: {
    padding: theme.spacing.unit * 2,
    paddingTop: 0,
  },
  textField: {
    marginRight: theme.spacing.unit,
  },
});

class CancelationPolicy extends React.Component {
  state = {
    enabled: get(this, 'props.organization.cancelation.enabled') || false,
    time: get(this, 'props.organization.cancelation.time') || 0,
    penalty: get(this, 'props.organization.cancelation.penalty') || 0,
    texts: loadTexts(TEXT_KEY, this.props.locale),
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedOrganization !== this.props.selectedOrganization) {
      this.setState({
        enabled: get(this, 'props.organization.cancelation.enabled') || false,
        time: get(this, 'props.organization.cancelation.time') || 0,
        penalty: get(this, 'props.organization.cancelation.penalty') || 0,
      });
    }
  }

  _onChangeEnabled = () => this.setState(state => ({ enabled: !state.enabled }));
  _onCancel = () => {
    const { organization } = this.props;
    this.setState({
      enabled: get(organization, 'cancelation.enabled') || false,
      time: get(organization, 'cancelation.time') || 0,
      penalty: get(organization, 'cancelation.penalty') || 0,
    });
  };
  _onSave = async () => {
    const { enabled, time, penalty } = this.state;
    await this.props.updateOrganizationCancelation({
      organization: this.props.organization._id,
      cancelation: { enabled, time, penalty },
    });
    await this.props.fetchUser();
    this.setState({
      enabled: get(this, 'props.organization.cancelation.enabled'),
      time: get(this, 'props.organization.cancelation.time'),
      penalty: get(this, 'props.organization.cancelation.penalty'),
    });
  };

  render() {
    const { classes, organization } = this.props;
    const { enabled, time, penalty, texts } = this.state;
    const disabled =
      (get(organization, 'cancelation.enabled') || false) === (enabled || false)
      && (get(organization, 'cancelation.time') || 0) === time
      && (get(organization, 'cancelation.penalty') || 0) === penalty
      || (time === '' || penalty === '');
    return (
      <Section
        onCancel={this._onCancel}
        onSave={this._onSave}
        saveDisabled={disabled}
        cancelDisabled={false}
      >
        <div className={classes.checkboxContainer}>
          <Checkbox
            checked={enabled}
            onChange={this._onChangeEnabled}
            color="primary"
            value="cancelation_enabled"
          />
          <Typography>
            {`${texts.section.cancellation_policy} ${organization.name}`}
          </Typography>
        </div>
        <Collapse in={enabled} timeout="auto" unmountOnExit>
          <div className={classes.textFieldContainer}>
            <TextField
              id="time"
              className={classes.textField}
              label={texts.label.time}
              value={time}
              onChange={event => this.setState({ time: event.target.value })}
              type="number"
            />
            <TextField
              id="penalty"
              label={`${texts.label.penalty} (%)`}
              value={penalty}
              onChange={event => this.setState({ penalty: event.target.value })}
              type="number"
            />
          </div>
        </Collapse>
      </Section>
    );
  }
}

const mapStateToProps = state => {
  const selectedOrganization = get(state, 'auth.selectedOrganization');
  return {
    organization: (get(state, 'auth.data.user.organizations') || []).find(o => o._id === selectedOrganization),
    locale: state.appState.locale
  };
};

const mapDispatchToProps = dispatch => ({
  updateOrganizationCancelation: params => dispatch(updateOrganizationCancelation(params)()),
  fetchUser: params => dispatch(fetchUser(params)()),
});

export default compose(
  withStyles(styles, { name: 'CancelationPolicy' }),
  connect(mapStateToProps, mapDispatchToProps)
)(CancelationPolicy);



// WEBPACK FOOTER //
// ./src/modules/organization/cards/CancelationPolicy/index.js